<template>
  <div class="content_box">
    <div
      class="content_box_inner"
      style="position: relative; margin-bottom: 20px"
    >
      <el-row :gutter="10" style="margin: 10px 0px">
        <el-col :span="18" style="font-size: 16px">园区营业收入</el-col>
        <el-col :span="6">
          <el-date-picker
            style="float: right"
            class="phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="times"
            value-format="yyyy"
            size="mini"
            @change="yearChange"
            :picker-options="pickerOptions"
            placeholder="选择年"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 15px" v-if="showArea">
        <el-col align="center"
          >{{
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }}情况</el-col
        >
      </el-row>
      <el-row style="margin: 10px 15px">
        <el-col :span="24">
          <Area
            v-if="showArea && tableData.length < 10"
            :area-data="areaData"
          />
          <areaRotate
            v-else-if="showArea && tableData.length >= 10"
            :area-data="areaData"
          />
        </el-col>
      </el-row>
    </div>

    <div
      class="content_box_inner"
      style="position: relative; margin-bottom: 20px"
    >
      <el-row :gutter="10" style="margin: 10px 0px 20px">
        <el-col :span="18" style="font-size: 16px">园区数据</el-col>
        <el-col :span="6">
          <el-date-picker
            style="float: right"
            class="phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="time5"
            value-format="yyyy"
            size="mini"
            @change="yearChange5"
            :picker-options="pickerOptions"
            placeholder="选择年"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row
        class="flex_box"
        :gutter="10"
        style="
          margin: 10px 15px 10px;
          display: flex;
          justify-content: space-between;
        "
      >
        <el-col
          :xs="24"
          :lg="4"
          style="
            background: #409eff;
            padding: 10px 10px 30px;
            margin-bottom: 10px;
          "
          v-for="(item, ind) in yqsjList"
          :key="ind"
        >
          <el-row>
            <div
              style="
                width: 60px;
                height: 60px;
                margin: 10px auto;
                border-radius: 50%;
                background: #fff;
                text-align: center;
              "
            >
              <i
                :class="item.icon"
                style="font-size: 40px; color: #409eff; line-height: 60px"
              ></i>
            </div>
          </el-row>
          <el-row>
            <div
              style="
                padding: 4px;
                text-align: center;
                font-size: 18px;
                color: #fff;
                font-weight: 600;
              "
            >
              {{ item.value }}
              <span style="font-size: 12px; font-weight: 400">{{
                item.unit
              }}</span>
            </div>
            <div style="text-align: center; font-size: 14px; color: #fff">
              {{ item.name }}
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div
      class="content_box_inner"
      style="position: relative; margin-bottom: 20px"
    >
      <el-row :gutter="10" style="margin: 10px 0px">
        <el-col :span="18" style="font-size: 16px">园区企业分析</el-col>
        <el-col :span="6">
          <el-date-picker
            style="float: right"
            class="phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="time4"
            value-format="yyyy"
            size="mini"
            @change="yearChange4"
            :picker-options="pickerOptions"
            placeholder="选择年"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row>
        <div class="button">
          <el-button
            :type="btnName4 == 1 ? 'primary' : ''"
            size="small"
            round
            @click="changeBtn4(1)"
            >企业个数</el-button
          >
          <el-button
            :type="btnName4 == 2 ? 'primary' : ''"
            size="small"
            round
            @click="changeBtn4(2)"
            >工业企业个数</el-button
          >
          <el-button
            :type="btnName4 == 3 ? 'primary' : ''"
            size="small"
            round
            @click="changeBtn4(3)"
            >规模工业企业个数</el-button
          >
        </div>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 15px">
        <el-col :xs="24" :lg="6" style="margin: 10px 0px">
          <el-row :gutter="10">
            <el-col
              :span="11"
              v-for="(item, index) in industryNumList"
              :key="index"
              style="padding: 10px; margin: 2px; box-shadow: 0 0 10px #ccc"
            >
              <div class="typeName" style="font-size: 12px; min-height: 32px">
                {{ item.name }}
              </div>

              <div
                class="typeName"
                style="font-size: 18px; text-align: center; margin: 6px 0"
              >
                {{ item.num }}
                <span style="font-size: 10px">{{ item.unit }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :lg="18">
          <el-row>
            <div id="yqflBox1" style="height: 300px"></div>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div
      class="content_box_inner clearfix"
      style="padding: 0; background: #f1f1f1; margin-bottom: 20px"
    >
      <div
        class="float_box"
        style="width: 49.6%; float: left; background: #fff; padding: 10px"
      >
        <el-row style="padding: 10px">
          <el-col :span="14" style="font-size: 18px">园区投资</el-col>
          <el-col :span="10">
            <el-date-picker
              style="float: right"
              class="phone_date"
              :editable="false"
              :clearable="false"
              type="year"
              v-model="time2"
              value-format="yyyy"
              size="mini"
              @change="yearChange2"
              :picker-options="pickerOptions"
              placeholder="选择年"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row style="padding: 6px">
          <el-col
            class="margin_right_20"
            v-for="(item, index) in tzList"
            :key="index"
            :xs="24"
            :lg="11"
            style="margin: 10px 0; box-shadow: 0 0 10px #ccc; padding: 8px"
          >
            <el-row>
              <el-col :span="8" style>
                <i
                  class="el-icon-office-building"
                  style="font-size: 60px; color: #409eff"
                ></i>
              </el-col>
              <el-col :span="16">
                <div style="font-size: 12px; padding: 4px 0">
                  {{ item.name }}
                </div>
                <div style="font-size: 16px; font-weight: 600">
                  {{ item.num }}
                  <span style="font-size:14px:font-weight:400">{{
                    item.unit
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px">
          <div class="button">
            <el-button
              :type="btnName2 == 1 ? 'primary' : ''"
              size="small"
              round
              @click="changeBtn2(1)"
              >基础设施建设</el-button
            >
            <el-button
              :type="btnName2 == 2 ? 'primary' : ''"
              size="small"
              round
              @click="changeBtn2(2)"
              >入驻项目固定资产</el-button
            >
          </div>
        </el-row>
        <el-row style="padding: 10px">
          <div id="yqtzId" style="height: 260px"></div>
        </el-row>
      </div>
      <div
        class="float_box"
        style="
          width: 49.6%;
          float: right;
          background: #fff;
          padding: 10px;
          margin-bottom: 0px;
        "
      >
        <el-row style="padding: 10px">
          <el-col :span="14" style="font-size: 16px">园区要素</el-col>
          <el-col :span="10">
            <el-date-picker
              style="float: right"
              class="phone_date"
              :editable="false"
              :clearable="false"
              type="year"
              v-model="time3"
              value-format="yyyy"
              size="mini"
              @change="yearChange3"
              :picker-options="pickerOptions"
              placeholder="选择年"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row style="padding: 6px">
          <el-col
            class="margin_right_20"
            v-for="(item, index) in yqysList"
            :key="index"
            :xs="24"
            :lg="11"
            style="margin: 10px 0; box-shadow: 0 0 10px #ccc; padding: 8px"
          >
            <el-row>
              <el-col :span="8" style>
                <i
                  class="el-icon-office-building"
                  style="font-size: 60px; color: #409eff"
                ></i>
              </el-col>
              <el-col :span="16">
                <div style="font-size: 12px; padding: 4px 0">
                  {{ item.name }}
                </div>
                <div style="font-size: 16px; font-weight: 600">
                  {{ item.num }}
                  <span style="font-size:14px:font-weight:400">{{
                    item.unit
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px">
          <div class="button">
            <el-button
              :type="btnName3 == 1 ? 'primary' : ''"
              size="small"
              round
              @click="changeBtn3(1)"
              >从业人员</el-button
            >
            <el-button
              :type="btnName3 == 2 ? 'primary' : ''"
              size="small"
              round
              @click="changeBtn3(2)"
              >劳动者报酬</el-button
            >
          </div>
        </el-row>
        <el-row style="padding: 10px">
          <div id="yqysId" style="height: 260px"></div>
        </el-row>
      </div>
    </div>

    <div class="content_box_inner" style="position: relative">
      <el-row :gutter="10" style="margin: 10px 0px">
        <el-col :span="8" style="font-size: 16px">园区分类</el-col>
      </el-row>
      <el-row>
        <div class="button">
          <el-button
            :type="btnName == 1 ? 'primary' : ''"
            size="small"
            round
            @click="changeBtn(1)"
            >园区类别</el-button
          >
          <el-button
            :type="btnName == 2 ? 'primary' : ''"
            size="small"
            round
            @click="changeBtn(2)"
            >产业分类</el-button
          >
          <el-button
            :type="btnName == 3 ? 'primary' : ''"
            size="small"
            round
            @click="changeBtn(3)"
            >园区级别</el-button
          >
        </div>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 0px">
        <el-col :xs="24" :lg="6" style="margin-bottom: 10px">
          <el-row :gutter="10">
            <el-col
              :span="11"
              v-for="(item, index) in yqflList"
              :key="index"
              style="padding: 10px; margin: 2px; box-shadow: 0 0 10px #ccc"
            >
              <div class="typeName" style="font-size: 12px; min-height: 32px">
                {{ item.type }}
              </div>

              <div
                class="typeName"
                style="font-size: 18px; text-align: center; margin: 6px 0"
              >
                {{ item.value }}
                <span style="font-size: 10px">个</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :lg="18">
          <el-row>
            <div id="yqflBox" style="height: 300px"></div>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Area from "@/components/Echarts/areaBear.vue";
import areaRotate from "@/components/Echarts/areaRotate1.vue";
import quarter from "@/components/dateUtils/quarter.vue";
import { export2Excel } from "@/utils/utils";
import echarts from "echarts";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      industryNumList: [],
      btnName: 1,
      btnName2: 1,
      btnName3: 1,
      btnName4: 1,
      yqflList: [],
      tzList: [],
      yqysList: [],
      yqsjList: [],
      showArea: false,
      loading: false,
      parkName: "",
      year: "",
      quarter: "",
      currentPage: 1,
      page: 1,
      pageSize: 20,
      total: 0,
      exportLabel: "<<点击此处可导出报表",
      dialogTableVisible: false,
      queryData: {},
      dataIndexOptions: [
        {
          value: "工业总产值",
          label: "工业总产值",
          unit: "亿元",
        },
        {
          value: "营业收入",
          label: "营业收入",
          unit: "亿元",
        },
        {
          value: "增加值",
          label: "增加值",
          unit: "亿元",
        },
        {
          value: "实缴税金",
          label: "实缴税金",
          unit: "亿元",
        },
        {
          value: "基础设施建设本年投资额",
          label: "基础设施建设本年投资额",
          unit: "亿元",
        },
      ],
      dataRangeOptions: [
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currQuarter", //时间类型
      dataIndex: "营业收入", //数据指标
      unit: "亿元",
      dataRange: "year", //数据类型
      times: "", //时间
      time1: "", //时间
      time2: "", //时间
      time3: "", //时间
      time4: "", //时间
      time5: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      },
    };
  },
  components: {
    Area,
    areaRotate,
    quarter,
    // areaContent,
  },
  watch: {
    dataRange: function (value, oldValue) {
      this.initData();
    },
  },
  methods: {
    //园区数据
    getYQSJ() {
      this.$axios
        .get(`/business/upgrade/park/selectParkStatistics?year=${this.time5}`)
        .then((res) => {
          let arr = res.data.data.filter((n) => n);

          this.yqsjList = arr;

          console.log(this.yqsjList);
          let iconList = [
            "el-icon-s-data",
            "el-icon-office-building",
            "el-icon-data-line",
            "el-icon-pie-chart",
            "el-icon-data-analysis",
          ];
          this.yqsjList.forEach((tem, i) => {
            tem.icon = iconList[i];
            console.log(tem.icon);
          });

          console.log(this.yqsjList);
        });
    },
    changeBtn1(type) {
      this.btnName = type;
      console.log(type);
    },

    changeBtn2(type) {
      this.btnName2 = type;
      this.$axios
        .get(
          `/business/upgrade/park/selectInvestAnalysisAll?year=${this.time2}`
        )
        .then((res) => {
          let arr = res.data.data.filter((n) => n);
          this.tzList = arr;
        });
      this.$axios
        .get(
          `/business/upgrade/park/selectInvestAnalysis?type=${type}&year=${this.time2}`
        )
        .then((res) => {
          let oList = res.data.data;
          console.log(oList);
          let xAxis = [];
          let yList = [];
          let ThisList = [];
          let LastList = [];
          let propList = [];
          for (let i = 0; i < oList.length; i++) {
            xAxis[xAxis.length] = oList[i].year;
            yList[yList.length] = oList[i].year;
            ThisList[ThisList.length] =
              oList[i].num != null ? oList[i].num : "--";
            LastList[LastList.length] =
              oList[i].last != null ? oList[i].last : "--";
            propList[propList.length] =
              oList[i].prop != null ? oList[i].prop : "--";
          }
          console.log(xAxis);
          console.log(ThisList);
          console.log(LastList);
          console.log(propList);
          let Dlist = [["数据", "当前", "同期", "增速"]];
          for (let i = 0; i < oList.length; i++) {
            Dlist[Dlist.length] = [
              yList[i],
              ThisList[i],
              LastList[i],
              // propList[i],
            ];
          }
          console.log(Dlist);
          // this.bar2("yqtzId", Dlist);
          let unit = "万元";
          this.bar3("yqtzId", xAxis, ThisList, LastList, propList, unit);
        });
    },

    changeBtn3(type) {
      this.btnName3 = type;
      this.$axios
        .get(
          `/business/upgrade/park/selectElementAnalysisAll?year=${this.time3}`
        )
        .then((res) => {
          let arr = res.data.data.filter((n) => n);
          this.yqysList = arr;
        });
      this.$axios
        .get(
          `/business/upgrade/park/selectElementAnalysis?type=${type}&year=${this.time3}`
        )
        .then((res) => {
          let oList = res.data.data;
          let xAxis = [];
          let yList = [];
          let ThisList = [];
          let LastList = [];
          let propList = [];
          for (let i = 0; i < oList.length; i++) {
            xAxis[xAxis.length] = oList[i].year;
            yList[yList.length] = oList[i].year;
            ThisList[ThisList.length] =
              oList[i].num != null ? oList[i].num : "--";
            LastList[LastList.length] =
              oList[i].last != null ? oList[i].last : "--";
            propList[propList.length] =
              oList[i].prop != null ? oList[i].prop : "--";
          }

          let unit;
          if (type == 1) {
            unit = "个";
            this.bar3("yqysId", xAxis, ThisList, LastList, propList, unit);
          } else {
            unit = "万元";
            this.bar3("yqysId", xAxis, ThisList, LastList, propList, unit);
          }
        });
    },

    changeBtn4(type) {
      this.btnName4 = type;
      this.$axios
        .get(`/business/upgrade/park/selectParkCompanyAll?year=${this.time4}`)
        .then((res) => {
          // let arr = res.data.data.filter((n) => n);
          if (res.data.data[0] != null) {
            this.industryNumList = res.data.data;
          } else {
            this.industryNumList = [];
          }
        });
      this.$axios
        .get(
          `/business/upgrade/park/selectParkCompany?type=${type}&year=${this.time4}`
        )
        .then((res) => {
          let oList = res.data.data;
          let xAxis = [];
          let yList = [];
          let ThisList = [];
          let LastList = [];
          let propList = [];
          for (let i = 0; i < oList.length; i++) {
            xAxis[xAxis.length] = oList[i].year;
            yList[yList.length] = oList[i].year;
            ThisList[ThisList.length] =
              oList[i].num != null ? oList[i].num : "--";
            LastList[LastList.length] =
              oList[i].last != null ? oList[i].last : "--";
            propList[propList.length] =
              oList[i].prop != null ? oList[i].prop : "--";
          }

          let unit = "个";

          this.bar3("yqflBox1", xAxis, ThisList, LastList, propList, unit);
        });
    },
    bar3(id, xAxis, ThisList, LastList, propList, unit) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "5.8%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisLabel: {
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：" + unit,
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],

        series: [
          {
            name: "当前",
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#72acf6" },
                { offset: 0.5, color: "#9c9ff0" },
                { offset: 1, color: "#9979f0" },
              ]),
            },
            barMaxWidth: 20,
            data: ThisList,
          },
          {
            name: "同期",
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 20,
            data: LastList,
          },
          {
            name: "增速",
            data: propList,
            type: "line",
            itemStyle: {
              normal: {
                color: "#DB3233",
              },
            },
          },
        ],
      };
      chart.setOption(option, true, false);
    },
    bar2(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        tooltip: {
          // trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "5.8%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: data,
        },
        xAxis: [
          {
            type: "category",
            data: data.name,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],

        series: [
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#72acf6" },
                { offset: 0.5, color: "#9c9ff0" },
                { offset: 1, color: "#9979f0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 20,
          },
          // {
          //   type: "line",
          //   yAxisIndex: 1,
          // },
        ],
      };
      chart.setOption(option, true, false);
    },

    changeBtn(type) {
      this.btnName = type;
      console.log(type);
      this.$axios
        .get(`/business/upgrade/park/selectParkDistributed?type=${type}`)
        .then((res) => {
          let cList = res.data.data.cityList;
          this.yqflList = res.data.data.cityList.reverse();
          let oList = res.data.data.districtList;

          let nList = [[]];
          for (let i = 0; i < cList.length; i++) {
            nList[0][nList[0].length] = cList[i].type;
          }

          nList[0].unshift("园区类别");

          for (let i = 0; i < oList.length; i++) {
            let temp = [];

            let element = [];
            for (let j = 0; j < oList[i].cityList.length; j++) {
              element[element.length] = oList[i].cityList[j].value;
            }

            nList[nList.length] = [oList[i].name].concat(element);
          }

          if (type == 1) {
            this.bar("yqflBox", nList);
          } else if (type == 2) {
            this.bar11("yqflBox", nList);
          } else {
            this.bar22("yqflBox", nList);
          }
        });
    },
    bar(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        tooltip: {
          // trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 12,
          },
        },
        grid: {
          top: "80px",
          left: "3%",
          right: "5.8%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: data,
        },
        xAxis: [
          {
            type: "category",
            // data: data.name,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],

        series: [
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#72acf6" },
                { offset: 0.5, color: "#9c9ff0" },
                { offset: 1, color: "#9979f0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00c3ff" },
                { offset: 0.5, color: "#f0c3ff" },
                { offset: 1, color: "#ffff1c" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#ef32d9" },
                { offset: 0.5, color: "#f0c3ff" },
                { offset: 1, color: "#89ffdf" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#cb202d" },
                { offset: 0.5, color: "#dc1e28" },
                { offset: 1, color: "#3366cc" },
              ]),
            },
            barMaxWidth: 20,
          },
        ],
      };
      chart.setOption(option, true, false);
    },
    bar11(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        tooltip: {
          // trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "5.8%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: data,
        },
        xAxis: [
          {
            type: "category",
            // data: data.name,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],

        series: [
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#72acf6" },
                { offset: 0.5, color: "#9c9ff0" },
                { offset: 1, color: "#9979f0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00c3ff" },
                { offset: 0.5, color: "#f0c3ff" },
                { offset: 1, color: "#ffff1c" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#ef32d9" },
                { offset: 0.5, color: "#f0c3ff" },
                { offset: 1, color: "#89ffdf" },
              ]),
            },
            barMaxWidth: 20,
          },
        ],
      };
      chart.setOption(option, true, false);
    },
    bar22(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        tooltip: {
          // trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "5.8%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: data,
        },
        xAxis: [
          {
            type: "category",
            // data: data.name,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],

        series: [
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#72acf6" },
                { offset: 0.5, color: "#9c9ff0" },
                { offset: 1, color: "#9979f0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 20,
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00c3ff" },
                { offset: 0.5, color: "#f0c3ff" },
                { offset: 1, color: "#ffff1c" },
              ]),
            },
            barMaxWidth: 20,
          },
        ],
      };
      chart.setOption(option, true, false);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.initData();
    },
    handleCurrentChange(val) {
      //跳转页
      this.page = val;
      this.initData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      console.log(this.dataRange);
      this.dataRange = "year";
      console.log(value);
      if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.parkName = row.area;
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    initData() {
      const self = this;
      this.loading = true;
      this.queryData = {};
      this.queryData.name = this.dataIndex;
      this.queryData.year = this.year;
      if (this.dataRange === "quarter") {
        this.queryData.quarter = this.quarter;
      }
      this.queryData.page = this.page;
      this.queryData.pageSize = this.pageSize;
      console.log(this.queryData);
      // /business/upgrade/park/selectParkFiveBus?year=2020
      // this.$axios.post("/business/garden/query", this.queryData).then((res) => {
      this.$axios
        .get(`/business/upgrade/park/selectParkFiveBus?year=${this.year}`)
        .then((res) => {
          console.log(res);
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            // unit: this.unit,
            unit: "万元",
          };
          this.showArea = false;
          this.loading = false;
          this.total = res.total;
          if (res.data.data) {
            res.data.data.forEach((item) => {
              const temp = {
                trend: "趋势",
                area: item.name,
                code: item.code,
              };
              this.areaData.xAxis.push(item.year);
              temp.currCount = item.sumBus;
              // temp.preCount = item.sntq;
              temp.growthRateCount = item.prop;
              // item.sntq == 0
              //   ? 0
              //   : ((item.bqzlj - item.sntq) / item.sntq) * 100;
              this.areaData.curr.name = "当前";
              // this.areaData.pre.name = "上年同期";
              this.areaData.profit.name = "增速";
              this.areaData.curr.data.push(temp.currCount);
              // this.areaData.pre.data.push(temp.preCount);
              this.areaData.profit.data.push(temp.growthRateCount);
              this.tableData.push(temp);
            });
            console.log(this.areaData);
            setTimeout(function () {
              self.showArea = true;
            }, 5);
          }
        });
    },
    getQuarter(value) {
      this.year = value.split(",")[0].slice(0, 4);
      let temp = "";
      if (value.split(",")[0].slice(5, 7) === "01") {
        this.quarter = 1;
        temp = this.year + "-03";
      } else if (value.split(",")[0].slice(5, 7) === "04") {
        this.quarter = 2;
        temp = this.year + "-06";
      } else if (value.split(",")[0].slice(5, 7) === "07") {
        this.quarter = 3;
        temp = this.year + "-09";
      } else if (value.split(",")[0].slice(5, 7) === "10") {
        this.quarter = 4;
        temp = this.year + "-12";
      }
      this.times =
        this.defaultMonthValue > temp ? temp : this.defaultMonthValue;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      this.times = this.defaultMonthValue;
      this.time1 = this.defaultMonthValue.substr(0, 4);
      this.time2 = this.defaultMonthValue.substr(0, 4);
      this.time3 = this.defaultMonthValue.substr(0, 4);
      this.time4 = this.defaultMonthValue.substr(0, 4);
      this.time5 = this.defaultMonthValue;
      this.year = year;
      //下面是几个if
      if (month >= 1 && month <= 3) {
        this.quarter = 1;
        return year + "-" + "01" + "," + year + "-" + "03";
      } else if (month >= 4 && month <= 6) {
        this.quarter = 2;
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        this.quarter = 3;
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        this.quarter = 4;
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    yearChange(value) {
      this.times = value + "-12";
      this.times =
        this.defaultMonthValue > this.times
          ? this.times
          : this.defaultMonthValue;
      this.year = value;
      this.initData();
    },
    yearChange1(value) {
      console.log(value);
      // this.getIndustryNum();
    },

    // getIndustryNum() {
    //   console.log(this.time1);
    //   this.$axios
    //     .get(`/business/upgrade/park/selectParkCompanyAll?year=${this.time1}`)
    //     .then((res) => {
    //       if (res.data.data[0] != null) {
    //         this.industryNumList = res.data.data;
    //       } else {
    //         this.industryNumList = [];
    //       }
    //     });
    // },

    yearChange2(value) {
      this.time2 = value;
      this.changeBtn2(this.btnName2);
    },

    yearChange3(value) {
      this.time3 = value;
      this.changeBtn3(this.btnName3);
    },
    yearChange4(value) {
      this.time4 = value;
      this.changeBtn4(this.btnName4);
    },
    yearChange5(value) {
      this.time5 = value;
      console.log("time5", this.time5);
      this.getYQSJ();
      // this.changeBtn4(this.btnName4);
    },
    dataIndexChange(value) {
      this.unit = this.dataIndexOptions.find((ele) => ele.value === value).unit;
      this.initData();
    },
    changeDataIndex(value) {
      if (value) {
        this.dataIndex = value;
      }
    },
    exportData() {
      let column = [
        {
          title: "园区",
          key: "area",
          rowspan: 2,
        },
        {
          title:
            this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
              .label +
            "(" +
            this.unit +
            ")",
          data: [
            {
              title: "本期止累计",
              toFixed: 2,
              key: "currCount",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "preCount",
            },
            {
              title: "同比增长(%)",
              toFixed: 1,
              key: "growthRateCount",
            },
          ],
          colspan: 3,
        },
      ];
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        let quarter = "";
        if (parseInt(this.times.slice(5, 7)) < 4) {
          quarter = "1";
        } else if (parseInt(this.times.slice(5, 7)) < 7) {
          quarter = "2";
        } else if (parseInt(this.times.slice(5, 7)) < 10) {
          quarter = "3";
        } else if (parseInt(this.times.slice(5, 7)) < 13) {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      }
      export2Excel(
        column,
        this.tableData,
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
          "_" +
          timeStr
      );
    },
  },
  created() {
    console.log(this.time5);
    this.defaultQuarterValue = this.getNowQuarter();
    this.initData();
    this.changeBtn(1);
    this.changeBtn1(1);
    this.changeBtn2(1);
    this.changeBtn3(1);
    this.changeBtn4(1);
    this.yearChange1();
    // this.getYQSJ();
  },
  mounted() {
    console.log("-----------", this.time5);
    this.time5 = this.time5.slice(0, 4);
    console.log("-----------", this.time5);

    this.getYQSJ();
  },
};
</script>
<style lang="less" scoped>
.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}
@media (min-width: 1200px) {
  .margin_right_20 {
    margin-right: 20px !important;
  }
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
  .flex_box {
    display: block !important;
  }
  .float_box {
    width: 100% !important;
    margin-bottom: 10px;
  }
}
</style>